/* eslint-disable default-param-last */
import { Map } from 'immutable';
import * as types from './ItemsSelectActionTypes';

export default function ItemsSelectReducer(state = Map(), action) {
  switch (action.type) {
    case types.SELECT_ALL_ITEMS:
      return state.set('selectedItems', action.selectedItems);
    case types.UNSELECT_ALL_ITEMS:
      return state.set('selectedItems', null);
    case types.SELECT_ITEMS:
      if (state.get('selectedItems')) {
        return state.set('selectedItems', state.get('selectedItems').concat(action.selectedItems));
      }
      return state.set('selectedItems', action.selectedItems);
    case types.UNSELECT_ITEMS:
      return state.set('selectedItems', state.get('selectedItems').filter(
        ({ id: id1 }) => !action.selectedItems.some(({ id: id2 }) => id2 === id1),
      ));
    case types.UNSELECT_ITEM:
      return state.set('selectedItems', state.get('selectedItems').filter(
        ({ id: id1 }) => action.selectedItem.id !== id1,
      ));
    default:
      return state;
  }
}
